import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Controls from "./Controls";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { Text, Circle, Group, Layer, Line, Rect, Stage } from "react-konva";
import Konva from "konva";

function Main() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "column", md: "row" },
        flexGrow: 1,
      }}
    >
      <Box sx={{ flex: 7 }}>
        <Controls />
      </Box>
      <Box
        sx={{
          flex: 13,
          minHeight: 600,
          backgroundColor: "#efefef",
          position: "relative",
          height: "100%",
        }}
      ></Box>
    </Box>
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
}

function Others(props: TabPanelProps) {
  const { children, ...other } = props;

  return (
    <HelmetProvider>
      <Main />
      <Helmet>
        <title>Others</title>
        <meta name="description" content="" />
      </Helmet>
    </HelmetProvider>
  );
}

export default Others;
